<div class="ss-page">

  <!-- Header -->
  <div class="ss-header">
    <div class="ss-header__left">
      <div class="ss-header__icon"><mat-icon>assessment</mat-icon></div>
      <div>
        <h1 class="ss-header__title">Balance Sumas y Saldos</h1>
        <p class="ss-header__sub">Consulta el estado de las cuentas contables por periodo</p>
      </div>
    </div>
    <div class="ss-header__actions">
      <button mat-stroked-button class="ss-btn-export" (click)="createExcel()" [disabled]="!ready">
        <mat-icon>list</mat-icon> Excel
      </button>
      <button mat-stroked-button class="ss-btn-export" (click)="createPDF()" [disabled]="!ready">
        <mat-icon>picture_as_pdf</mat-icon> PDF
      </button>
    </div>
  </div>

  <!-- Filtros -->
  <div class="ss-filters">

    <div class="ss-filters__row">
      <mat-form-field appearance="outline" class="ss-field">
        <mat-label>Desde</mat-label>
        <mat-select #s1 (selectionChange)="changeFromFilterBalance(s1.value)" [(value)]="fromFilterBalance">
          <mat-option value="0">Apertura</mat-option>
          <mat-option *ngFor="let m of ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']; let i = index; trackBy: trackByIndex" [value]="i+1">{{ m }}</mat-option>
          <mat-option value="13">Regularización</mat-option>
          <mat-option value="14">Cierre</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="ss-field">
        <mat-label>Hasta</mat-label>
        <mat-select #s2 (selectionChange)="changeToFilterBalance(s2.value)" [(value)]="toFilterBalance">
          <mat-option value="0">Apertura</mat-option>
          <mat-option *ngFor="let m of ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']; let i = index; trackBy: trackByIndex" [value]="i+1">{{ m }}</mat-option>
          <mat-option value="13">Regularización</mat-option>
          <mat-option value="14">Cierre</mat-option>
        </mat-select>
      </mat-form-field>

      <app-select class="ss-field" [(ngModel)]="levelAccounts"
        [config]="{ label: 'Nivel de cuentas', options: levelAccountsOptions }">
      </app-select>

      <mat-slide-toggle [ngModel]="globalFilterBalance" (change)="changeGlobalFilterBalance()" class="ss-toggle">
        Todas las actividades
      </mat-slide-toggle>

      <button mat-flat-button class="ss-btn-primary" (click)="getData()">
        <mat-icon>search</mat-icon> Consultar
      </button>
    </div>

    <!-- Grupos -->
    <div class="ss-groups">
      <span class="ss-groups__label">Grupos</span>
      <div class="ss-groups__checks">
        <mat-checkbox *ngFor="let g of [1,2,3,4,5,6,7,8,9]; trackBy: trackByIndex" [(ngModel)]="group[g].checked" class="ss-group-check">
          {{ g }}
        </mat-checkbox>
        <mat-checkbox (change)="toggle(10, $event)" class="ss-group-check ss-group-check--all">
          Todas
        </mat-checkbox>
      </div>
    </div>

  </div>

  <!-- Estado vacío -->
  <div class="ss-empty" *ngIf="!ready && !dataSource?.length">
    <mat-icon>insert_chart</mat-icon>
    <p>Selecciona el periodo y pulsa <strong>Consultar</strong></p>
  </div>

  <!-- Tabla -->
  <div class="ss-table-wrap" *ngIf="dataSource?.length">

    <!-- Filas ocultas para Excel (mantener funcionalidad) -->
    <ng-container *ngIf="ready">
      <table id="sumasysaldos" style="display:none">
        <tr><td>{{userCompany?.companyName}}</td></tr>
        <tr>
          <td>Desde: Mes {{fromFilterBalance}}</td>
          <td>Hasta: Mes {{toFilterBalance}}</td>
          <td>Niveles: {{levelAccounts}}</td>
          <td>Grupos: <span *ngFor="let temp of groups; trackBy: trackByIndex">{{temp}} </span></td>
          <td></td><td></td>
        </tr>
        <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
        <tr>
          <td>Cuenta</td><td>Título</td>
          <td>Debe</td><td>Haber</td>
          <td>Saldo Deudor</td><td>Saldo Acreedor</td>
        </tr>
        <tr *ngFor="let item of dataSource; trackBy: trackByIndex">
          <td>{{item.accountNumber}}</td>
          <td>{{item.title}}</td>
          <td data-t="n">{{item.debe}}</td>
          <td data-t="n">{{-item.haber}}</td>
          <td data-t="n">{{ item.item4 == 0 ? 0 : item.saldoDeudor }}</td>
          <td data-t="n">{{ item.item3 == 0 ? 0 : item.saldoAcreedor }}</td>
        </tr>
        <tr>
          <td></td><td>Total Balance</td>
          <td data-t="n">{{totalDebe}}</td>
          <td data-t="n">{{-totalHaber}}</td>
          <td data-t="n">{{totalDeudor}}</td>
          <td data-t="n">{{totalAcreedor}}</td>
        </tr>
        <tr>
          <td></td><td>Saldo</td>
          <td></td><td></td>
          <td data-t="n">{{saldoDeudor}}</td>
          <td data-t="n">{{saldoAcreedor}}</td>
        </tr>
      </table>
    </ng-container>

    <!-- Tabla visible -->
    <table class="ss-table">
      <thead>
        <tr>
          <th class="ss-th ss-th--account">Cuenta</th>
          <th class="ss-th ss-th--title">Título</th>
          <th class="ss-th ss-th--num">Debe</th>
          <th class="ss-th ss-th--num">Haber</th>
          <th class="ss-th ss-th--num">Saldo Deudor</th>
          <th class="ss-th ss-th--num">Saldo Acreedor</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of dataSource; let i = index; trackBy: trackByIndex" class="ss-row" [class.ss-row--even]="i % 2 === 0">
          <td class="ss-td ss-td--account"
            [class.hover-ledger]="levelAccounts == '0'"
            [style.cursor]="levelAccounts == '0' ? 'pointer' : 'default'"
            (click)="levelAccounts == '0' ? ledger(item.accountId, item.title, item.accountNumber) : null">
            <span class="ss-account-num">{{ item.accountNumber }}</span>
          </td>
          <td class="ss-td ss-td--title">{{ item.title }}</td>
          <td class="ss-td ss-td--num">{{ item.debe }}</td>
          <td class="ss-td ss-td--num ss-td--red">{{ -item.haber }}</td>
          <td class="ss-td ss-td--num">{{ item.item4 == 0 ? '0' : item.saldoDeudor }}</td>
          <td class="ss-td ss-td--num ss-td--red">{{ item.item3 == 0 ? '0' : item.saldoAcreedor }}</td>
        </tr>
      </tbody>
      <tfoot *ngIf="ready">
        <tr class="ss-tfoot-total">
          <td class="ss-td"></td>
          <td class="ss-td ss-td--footer-label">Total Balance</td>
          <td class="ss-td ss-td--num"><strong>{{ totalDebe }}</strong></td>
          <td class="ss-td ss-td--num ss-td--red"><strong>{{ -totalHaber }}</strong></td>
          <td class="ss-td ss-td--num"><strong>{{ totalDeudor }}</strong></td>
          <td class="ss-td ss-td--num ss-td--red"><strong>{{ totalAcreedor }}</strong></td>
        </tr>
        <tr class="ss-tfoot-saldo">
          <td class="ss-td"></td>
          <td class="ss-td ss-td--footer-label">Saldo</td>
          <td class="ss-td"></td>
          <td class="ss-td"></td>
          <td class="ss-td ss-td--num ss-td--red"><strong>{{ saldoDeudor }}</strong></td>
          <td class="ss-td ss-td--num ss-td--red"><strong>{{ saldoAcreedor }}</strong></td>
        </tr>
      </tfoot>
    </table>
  </div>

</div>
